import React, { useState } from 'react'
import './rating.css'

function NumberRating({ range, onSelectRange, rangeValue }) {
    const [rate, setRate] = useState(rangeValue || null)
    const [tempRate, setTempRate] = useState(null)
    var number = [];
    const hoverRating = (range) => {
        setTempRate(rate)
        setRate(range)
    }
    const hoverRatingRemove = () => {
        setRate(tempRate)
    }
    for (let i = 0; i < range; i++) {
        var klass = "star-rating__star";
        if (rate >= i && rate != null) {
            klass += " is-selected";
        }
        number.push(
            <label className={`${klass} cursor-pointer`} onClick={() => { onSelectRange(i + 1); setRate(i);setTempRate(i) }} key={i} value={i} onMouseOver={() => hoverRating(i)} onMouseOut={() => hoverRatingRemove()}>
                <div>{i + 1}</div>
            </label>
        );
    }
    return (
        <div className="star-rating flex justify-evenly">{number}</div>
    )
}

export default NumberRating
